export default __webpack_public_path__ + "d404cf3aa21de5bbd75317cd0f76f825.svg";